"use client";

import { useEffect, useRef, useState, useTransition } from "react";

import classNames from "classnames";
import { useLocale, useTranslations } from "next-intl";

import type { SupportedLocales } from "@/shared/types";

import { usePathname, useRouter } from "@/shared/lib/navigation";

import styles from "./LocaleSwitcher.module.css";

export function LocaleSwitcher() {
    const locale = useLocale();
    const router = useRouter();
    const pathname = usePathname();
    const [isPending, startTransition] = useTransition();
    const t = useTranslations("Locale");

    function selectLocale(nextLocale: SupportedLocales) {
        if (nextLocale === locale) return; // Do nothing if clicking current language
        startTransition(() => {
            const { searchParams } = new URL(window.location.href);
            router.replace(pathname + (searchParams.toString() ? `?${searchParams.toString()}` : ""), {
                locale: nextLocale,
            });
        });
    }

    return (
        <div className="flex items-center gap-4">
            <button
                aria-label={t("switchToEnglish")}
                className={`text-lg text-primary ${locale === "en-US" ? "font-bold" : ""}`}
                disabled={isPending || locale === "en-US"}
                onClick={() => selectLocale("en-US")}
                type="button"
            >
                EN
            </button>
            <button
                aria-label={t("switchToGerman")}
                className={`text-lg text-primary ${locale === "de-DE" ? "font-bold" : ""}`}
                disabled={isPending || locale === "de-DE"}
                onClick={() => selectLocale("de-DE")}
                type="button"
            >
                DE
            </button>
        </div>
    );
}
